import styled from '@emotion/styled';
import { Colors } from '../../../../../styles/variables/colors';

export const Row = styled.div<{ hasCursor: boolean }>`
    padding: 0 24px;

    @media (max-width: 1024px) {
        padding: 0 16px;
    }

    &:hover {
        background-color: ${Colors.hoverColor};
        cursor: ${({ hasCursor }) => (hasCursor ? 'pointer' : '')};
    }
`;

export const VisaOfferRow = styled.div`
    padding: 0 24px;

    @media (max-width: 1024px) {
        padding: 0 16px;
    }

    &:hover {
        background-color: ${Colors.hoverColor};
        cursor: pointer;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    @media screen and (max-width: 768px) {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        /* padding: 16px 0 12px; */
    }
`;
